import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PackageService } from 'src/app/models/package-service.model';
import { PackageItem } from 'src/app/models/package-item.model';
import { Product } from 'src/app/models/product';
import { PackageServiceService } from 'src/app/services/package-service.service';
import { ToastService } from 'src/app/services/toast.service';
import { SelectItem } from 'primeng/api';
import { ProductType } from 'src/app/models/enums';

@Component({
  selector: 'app-package-service-form',
  templateUrl: './package-service-form.component.html',
  styleUrls: ['./package-service-form.component.scss']
})
export class PackageServiceFormComponent implements OnInit {

  packageServiceForm: FormGroup;
  packageService: PackageService;
  isEdit: boolean = false;
  products: Product[] = [];
  listProductsToItens: SelectItem[] = [];
  packageItems: PackageItem[] = [];
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private packageServiceService: PackageServiceService,
    private toastService: ToastService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.products = config.data?.products || [];
    this.packageService = config.data?.packageService || new PackageService();
    this.isEdit = config.data?.isEdit || false;
  }

    ngOnInit(): void {
    this.initForm();
    this.loadListProductsToItens();
    this.setupProduct();
  }

  loadListProductsToItens(): void {
    const products = this.products.filter(p => p.productType !== ProductType.PackageService);
    this.listProductsToItens = products.map(p => ({
      label: `${p.name} - ${p.price?.value ? 'R$ ' + p.price.value : 'Por tamanho'}`,
      value: p
    }));
  }

  initForm(): void {
    this.packageServiceForm = this.fb.group({
      name: [this.packageService.name, [Validators.required]],
      description: [this.packageService.description],
      daysDuration: [this.packageService.daysDuration, [Validators.required, Validators.min(1)]],
      product: [null, [Validators.required]],
      active: [this.packageService.active]
    });
  }

  setupProduct(): void {
    if (this.isEdit && this.packageService.product) {
      const foundProduct = this.products.find(p => p.id === this.packageService.product.id);
      if (foundProduct) {
        this.packageServiceForm.patchValue({ product: foundProduct });
      } else {
        this.products.push(this.packageService.product);
        this.packageServiceForm.patchValue({ product: this.packageService.product });
      }
      this.loadPackageItems();

    }
  }

    loadPackageItems(): void {
    if (this.isEdit && this.packageService.id) {
      console.log('Carregando itens para o pacote ID:', this.packageService.id);
      this.packageServiceService.findItemsByPackageServiceId(this.packageService.id).subscribe({
        next: (data) => {
          console.log('Itens carregados:', data);
          this.packageItems = data;

          this.packageItems.forEach(item => {
            console.log('Processando item:', item);
            console.log('Produto do item:', item.product);

            if (item.product) {
              const foundProduct = this.products.find(p => Number(p.id) === Number(item.product.id));

              if (foundProduct) {
                console.log('Produto encontrado na lista:', foundProduct);
                item.product = foundProduct;
              } else {
                console.log('Produto não encontrado na lista, adicionando:', item.product);
                this.products.push(item.product);
                this.loadListProductsToItens();
              }
            }
          });

          console.log('Lista final de produtos para itens:', this.listProductsToItens);
          console.log('Itens finais:', this.packageItems);
        },
        error: (error) => {
          console.error('Erro ao carregar itens do pacote:', error);
          this.toastService.error('Erro ao carregar itens do pacote');
        }
      });
    } else {
      console.log('Não é edição ou não tem ID do pacote');
    }
  }

  addPackageItem(): void {
    const newItem = new PackageItem();
    newItem.packageService = this.packageService;
    newItem.quantity = 1;
    newItem.product = null;
    this.packageItems.push(newItem);
    console.log('Novo item adicionado:', newItem);
  }

  isProductAlreadySelected(product: Product | null, currentItem?: PackageItem): boolean {
    if (!product) return false;
    return this.packageItems.some(item =>
      item !== currentItem && item.product && item.product.id === product.id
    );
  }

  onProductChange(item: PackageItem, selectedProduct: Product | null): void {
    if (selectedProduct && this.isProductAlreadySelected(selectedProduct, item)) {
      item.product = null;
      this.toastService.warning('Este produto já foi adicionado ao pacote');
    }
  }

    getAvailableProducts(currentItem: PackageItem): SelectItem[] {
    const availableProducts = this.products.filter(product => {
      if (product.productType === ProductType.PackageService) {
        return false;
      }

      const isSelectedInOtherItem = this.packageItems.some(item =>
        item !== currentItem && item.product && item.product.id === product.id
      );

      return !isSelectedInOtherItem;
    });

    return availableProducts.map(p => ({
      label: `${p.name} - ${p.price?.value ? 'R$ ' + p.price.value : 'Por tamanho'}`,
      value: p
    }));
  }

  getPackageServiceProducts(): SelectItem[] {
    const packageServiceProducts = this.products.filter(product =>
      product.productType === ProductType.PackageService
    );

    return packageServiceProducts.map(p => ({
      label: `${p.name} - ${p.price?.value ? 'R$ ' + p.price.value : 'Por tamanho'}`,
      value: p
    }));
  }

  removePackageItem(index: number): void {
    this.packageItems.splice(index, 1);
  }

  compareProducts(product1: Product | null, product2: Product | null): boolean {
    if (!product1 || !product2) return false;
    return Number(product1.id) === Number(product2.id);
  }

  compareSelectItems(item1: SelectItem, item2: SelectItem): boolean {
    if (!item1?.value || !item2?.value) return false;
    return Number(item1.value.id) === Number(item2.value.id);
  }

  save(): void {
    if (this.packageServiceForm.valid) {
      this.loading = true;
      const formValue = this.packageServiceForm.value;

      const payload = {
        name: formValue.name,
        description: formValue.description,
        daysDuration: formValue.daysDuration,
        active: formValue.active,
        productId: formValue.product.id,
        items: this.packageItems
          .filter(item => item.product && item.quantity)
          .map(item => ({
            productId: item.product.id,
            quantity: item.quantity
          }))
      };

      if (this.isEdit) {
        this.packageServiceService.update(this.packageService.id, payload).subscribe({
          next: (data) => {
            this.toastService.success('Pacote de serviço atualizado com sucesso');
            this.ref.close(data);
          },
          error: (error) => {
            console.error('Erro ao atualizar pacote de serviço:', error);
            this.toastService.error('Erro ao atualizar pacote de serviço');
            this.loading = false;
          }
        });
      } else {
        this.packageServiceService.create(payload).subscribe({
          next: (data) => {
            this.toastService.success('Pacote de serviço criado com sucesso');
            this.ref.close(data);
          },
          error: (error) => {
            console.error('Erro ao criar pacote de serviço:', error);
            this.toastService.error('Erro ao criar pacote de serviço');
            this.loading = false;
          }
        });
      }
    } else {
      this.toastService.warning('Por favor, preencha todos os campos obrigatórios');
    }
  }

  cancel(): void {
    this.ref.close();
  }
}
